export * from './template-list.service';



// WEBPACK FOOTER //
// ./src/app/content/shared/services/template-list/index.ts